import { IconLetterCase } from '@tabler/icons-react'
import { TableColumnType } from 'antd'

import { TextDisplayBlock as RenderTextDisplayBlock } from '../../templateRenderer/DisplayBlocks/TextDisplayBlock'
import { TextDisplayBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  TextAreaField,
  TypeOption,
} from './_BaseBlockConfig'
import { TextWrapper } from './TextCaptureBlockConfig'

import antdTableSorter from '@/utils/antdTableSorter'

class Config extends BaseBlockConfig<TextDisplayBlock> {
  public override kind = 'display' as const
  public override type = 'text' as const

  public override enableBlockToColumnDisplay = true

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Body text',
    icon: IconLetterCase,
    hideName: true,
    hideDescription: true,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'content',
      label: 'Text value',
      field: TextAreaField,
      required: true,
    },
  ]

  public override mapFormValueToBlock(
    block: TextDisplayBlock
  ): TextDisplayBlock {
    return block
  }

  public override mapBlockToColumnDisplay(
    block: TextDisplayBlock
  ): React.ReactNode {
    return <TextWrapper>{block.content}</TextWrapper>
  }

  public override mapBlockToColumnSort(
    block: TextDisplayBlock
  ): TableColumnType<unknown> {
    return {
      sorter: (a, b) => {
        const [aBlock, bBlock] = this.getAandBBlocks(block, a, b)

        if (!aBlock || !bBlock) return 0

        if (aBlock.kind === 'display' && bBlock.kind === 'display') {
          return antdTableSorter(aBlock, bBlock, 'content')
        }

        return 0
      },
    }
  }

  public override renderBlock(block: TextDisplayBlock): React.ReactNode {
    return <RenderTextDisplayBlock block={block} />
  }
}

export const TextDisplayBlockConfig = new Config()
